module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA2CAYAAACbZ/oUAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFGSURBVGiB7ZoxSsRQEEDfBMttBA+QG3iATWnvFRbEYm+jtXgOtxEsPEZAD2BpP9tE2I0fjPszP9nJPEgz8DPz+BP4w4+o6g3wBNT4pgW2oqof+Jf9oRVV1amrKEk1dQGluUjEnoH30oUY0QB3RxH9zWaS0gxQ1U1fbnEtHcLeCWHvhLB3Qtg7qaPlrarWpQsx4rofiGnJO4sTTn3DX8B36UKMWAFXR5EYD50Twt4JYe+EsAWquiqRZwjmwp3si3WeoZgKH8g2lnn+g5nwHGXBSHiusmAgPGdZGFl47rKQHg9P4i/Z7uJ9DB5E5PHUxaMID9zZeoxcwGXO4uyWPoc2PiRL+NxkIb+lG+C1e0rxlrM4S1hEdsAu5x2liWnJOyHsnRD2Tgh7Z3HCqZPW2tEl+bofiD8AvFMBn1MXUZC2Au5ZhnQLbPez6KfHb4WPmAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yituikuan_icon.png
// module id = qBA1
// module chunks = 1